import { Stack } from '@pairy/pds-react';
import { useAtomValue } from 'jotai';

import { userInfoAtom } from '@/state/user/atom';
import useCheckUpdatingFile from '@/hooks/useCheckUpdatingFile';

import PreviewButton from './PreviewButton';
import DeleteButton from './DeleteButton';
import EditButton from './EditButton';

interface Props {
  fileId: number;
  fileName: string;
  fileThumbnail: string;
  handleHoverSideAction?: (open: boolean) => void;
}

const FileRelatedButtons = ({
  fileId,
  fileName,
  fileThumbnail,
  handleHoverSideAction,
}: Props) => {
  const { isDisabled, handleDisabledButtonClick } = useCheckUpdatingFile();

  const userInfo = useAtomValue(userInfoAtom);

  const userId = userInfo?.id ?? null;
  const userPlan = userInfo?.subscriptionPlan?.name ?? 'Free';

  const previewUrl = `/user/pdf-preview?fileId=${fileId}&userId=${userId}`;

  return (
    <Stack gap={8}>
      <PreviewButton
        href={previewUrl}
        isDisabled={isDisabled}
        handleDisabledButtonClick={handleDisabledButtonClick}
      />
      <DeleteButton
        fileId={fileId}
        fileName={fileName}
        isDisabled={isDisabled}
        handleDisabledButtonClick={handleDisabledButtonClick}
      />
      <EditButton
        fileId={fileId}
        fileName={fileName}
        fileThumbnail={fileThumbnail}
        userPlan={userPlan}
        isDisabled={isDisabled}
        handleDisabledButtonClick={handleDisabledButtonClick}
        handleHoverSideAction={handleHoverSideAction}
      />
    </Stack>
  );
};

export default FileRelatedButtons;
